import BaseAbility from 'umg-ember-backend/abilities/base';

export default class CoopPartnerAbility extends BaseAbility {}
